import { createAction } from 'redux-actions';
import sportBackend from '../service/sportBackend';
import sportConfig from '../config/sports';

export default createAction('LOAD_SPORT_DATA', async ({ country, language, storeState }) => {
  const leagueIds = sportConfig[country][storeState.mappedSportRouteParam].leagues;
  const sportData = await sportBackend.fetchTeamsByLeagueIds(language, leagueIds);

  return { sportData };
});



// WEBPACK FOOTER //
// ./src/action/loadSportData.js